import React from 'react'
import { ResponsiveView } from '@/components/ui'
import { ConditionsTableDesktop, ConditionsTableMobile } from './components'
import type { IConditionsTableProps } from './interfaces'
import './styles.scss'

const LandingConditionsTable: React.FC<IConditionsTableProps> = props => (
  <ResponsiveView Mobile={ConditionsTableMobile} Desktop={ConditionsTableDesktop} componentsProps={props} />
)

export default LandingConditionsTable
